// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"772":"9315b3fe","980":"5a8cf7db"}[chunkId] + ".chunk.css";
};